import { initialiseDatadog, setDatadogConsent } from '@library/observability/browser'

/**
 * Starts RUM monitoring including XHR / fetch observation
 */
initialiseDatadog()

/**
 * Check user's storage consent for Datadog
 */
setDatadogConsent()
